import "./CompleteTaskModal.css";

import { Dispatch, SetStateAction } from "react";

import { TaskConstants } from "../../../../constants/workflow/TaskConstants";
import { TaskPanelData } from "../../../../models";
import { ServiceError } from "../../../../service/Shared";
import { ActionButtons, Column, FormLabel, Modal, ReadonlyText, Row, Select } from "../../../../widget";
import { useCompleteTaskModal } from "./useCompleteTaskModal";

interface CompleteTaskModalProps {
  show: boolean;
  task: TaskPanelData;
  closeModal: () => void;
  closePanel: () => void;
  handleRefresh: () => void;
  setErrors?: Dispatch<SetStateAction<ServiceError[] | undefined>>;
}

export const CompleteTaskModal = ({
  show,
  task,
  closeModal,
  closePanel,
  handleRefresh,
  setErrors,
}: CompleteTaskModalProps): JSX.Element => {
  const { handleCloseModal, handleSubmit, setResolution, resolution, isHandleSubmitLoading } = useCompleteTaskModal({
    closeModal,
    closePanel,
    handleRefresh,
    setErrors,
    task,
  });

  return (
    <Modal show={show} title="Complete task" onClose={handleCloseModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Row spacingV="l">
          <Column offset={3} span={6}>
            <FormLabel label="Task" />
            <ReadonlyText value={task.name} />
          </Column>
        </Row>
        <Row spacingV="l">
          <Column offset={3} span={6}>
            <FormLabel label="Status" />
            <ReadonlyText value={task.status} />
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <div className="CompleteTaskModalWrapper">
              <Select
                label="Resolution"
                placeholder="Select resolution"
                data={TaskConstants.RESOLUTION_SELECT_DATA}
                value={resolution}
                onChange={(key) => setResolution(key)}
              />
            </div>
          </Column>
        </Row>
        <Row justify="center">
          <ActionButtons
            disabled={resolution === undefined}
            onCancel={handleCloseModal}
            submitButtonLabel="Save"
            isLoading={isHandleSubmitLoading}
          />
        </Row>
      </form>
    </Modal>
  );
};
